import { dataAccessEnvironment } from './data-access-environment';

/**
 * Authorization header for APIs that use an authToken from AuthWS
 */
export class AuthHeaders {
  readonly Authorization: string;

  constructor() {
    this.Authorization = `Bearer ${dataAccessEnvironment.authToken}`;
  }
}
